import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgForbiddenIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 21.622 21.615",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M818.335,4.234A10.274,10.274,0,0,1,826.008,1.1a10.7,10.7,0,0,1,7.673,3.134,10.274,10.274,0,0,1,3.134,7.673,10.7,10.7,0,0,1-3.134,7.673,10.274,10.274,0,0,1-7.673,3.134,10.7,10.7,0,0,1-7.673-3.134,10.274,10.274,0,0,1-3.134-7.673A9.739,9.739,0,0,1,818.335,4.234ZM825.9,20.445a8.3,8.3,0,0,0,5.3-1.837l-12.1-12.1a8.3,8.3,0,0,0-1.837,5.3,8.011,8.011,0,0,0,2.594,6.052A8.011,8.011,0,0,0,825.9,20.445Zm6.809-3.35a8.3,8.3,0,0,0,1.837-5.3,8.011,8.011,0,0,0-2.594-6.052A8.444,8.444,0,0,0,820.6,4.991Z",
		transform: "translate(-815.193 -1.1)"
	})
});
export default SvgForbiddenIcon;
